import { Col, DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import { copyDefaultTimeRange } from '../../../../../../utils/dateRange';
import { Label } from '../../../../../common/Label/Label';
import styles from '../../../Style/DatasetInfo.module.scss';

// Helper function to convert date strings to Moment objects
const ensureMoment = (date: string | Moment | null): Moment | null => {
  if (!date) return null;
  return typeof date === 'string' ? moment(date) : date;
};

export const DateRangeSelector = ({
  id,
  dateRange,
  disabledDate,
  onDateChange,
  isDisabled,
}: {
  id: string;
  dateRange?:
    | [string | Moment, string | Moment]
    | [string, string]
    | [Moment, Moment];
  disabledDate: (current: Moment) => boolean;
  onDateChange: (value: any) => void;
  isDisabled: boolean;
}) => {
  const momentDateRange = dateRange
    ? ([ensureMoment(dateRange[0]), ensureMoment(dateRange[1])] as [
        Moment,
        Moment
      ])
    : undefined;

  const handleDateChange = (dates: [Moment | null, Moment | null] | null) => {
    if (dates && dateRange && dates[0] && dates[1]) {
      const updatedDates = [
        copyDefaultTimeRange(ensureMoment(dateRange[0]) as Moment, dates[0]),
        copyDefaultTimeRange(ensureMoment(dateRange[1]) as Moment, dates[1]),
      ];
      onDateChange(updatedDates);
    }
  };

  return (
    <Col span={12}>
      <Label
        label={
          <div className={styles.DateLabel}>
            <span className={styles.startDateLabel}>Start Date</span>
            <span>End Date</span>
          </div>
        }
      >
        <DatePicker.RangePicker
          id={id}
          data-testid={`PointPanel-Date_Selection`}
          value={momentDateRange}
          disabledDate={disabledDate}
          format={['YYYY-MM-DD', 'YYYY-MM-DD']}
          onChange={handleDateChange}
          disabled={isDisabled}
        />
      </Label>
    </Col>
  );
};
